import { render, staticRenderFns } from "./WhyWrapper.vue?vue&type=template&id=664accd1&scoped=true"
import script from "./WhyWrapper.vue?vue&type=script&lang=js"
export * from "./WhyWrapper.vue?vue&type=script&lang=js"
import style0 from "./WhyWrapper.vue?vue&type=style&index=0&id=664accd1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664accd1",
  null
  
)

export default component.exports